import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import styles from './LocationSlider.module.css';
import sliderImg from '../../../images/no-unit-image.svg';
import { AnyIfEmpty } from 'react-redux';

const LocationSlider = ({ locationImgs }: AnyIfEmpty<object>) => {
    return (
        <div className="LocationSlider">
            <Carousel showThumbs={false} autoPlay={true} infiniteLoop={true} showArrows={false} showStatus={false} emulateTouch>
                {locationImgs?.length > 0 ? (
                    locationImgs?.map((image: string, index: number) => (
                        <div key={index} className={styles.sliderItem} onClick={(e) => e.preventDefault()}>
                            <img className={styles.banner} src={image ? image : sliderImg} />
                        </div>
                    ))
                ) : (
                    <div className={styles.sliderItem}>
                        <img className={styles.banner} src={sliderImg} alt="Dummy Image" />
                    </div>
                )}
            </Carousel>
        </div>
    );
};

export default LocationSlider;
